import { Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Button } from "react-admin";
import ModalTitle, { modalCancelButtonSx, withModalSx } from "./ModalTitle";

const ConflictErrorModal = ({ open, title, items, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={withModalSx()}
    >
      <ModalTitle
        icon={<ErrorOutlineIcon />}
        title={title}
        color="error"
      />
      <DialogContent dividers>
        {items &&
          items.map((it, idx) => (
            <Typography
              sx={{ p: 4 }}
              key={idx}
            >
              {JSON.stringify(it)}
            </Typography>
          ))}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="outlined"
          color="error"
          size="medium"
          label="OK"
          sx={modalCancelButtonSx}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConflictErrorModal;
